import React from 'react';
import PropTypes from 'prop-types';
import { Container, ProjectsList } from './styles';
import Title from '../../UI/Title';
import ProjectItem from '../../UI/Project';

const WorkExperience = ({ title, projects }) => (
  <Container>
    <Title text={title} />
    <ProjectsList>
      { projects.map(item =>
        <ProjectItem
          key={item.id}
          id={item.id}
          title={item.title}
          link={item.link}
          src={item.cover}
          alt={item.alt}
        />
      )}
    </ProjectsList>
  </Container>
);

WorkExperience.propTypes = {
  title: PropTypes.string,
  projects: PropTypes.array,
};

export default WorkExperience;
